// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w7zOUywgRBCJyj7SF6FE:has(img) {
    border: 1px solid var(--color-electric-blue-500);
    padding: 3px;
}

.w7zOUywgRBCJyj7SF6FE img {
    border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/components/header/header-right-section/UserAvatar.module.css"],"names":[],"mappings":"AAAA;IACI,gDAAgD;IAChD,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".avatarContainer:has(img) {\n    border: 1px solid var(--color-electric-blue-500);\n    padding: 3px;\n}\n\n.avatarContainer img {\n    border-radius: 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avatarContainer": `w7zOUywgRBCJyj7SF6FE`
};
export default ___CSS_LOADER_EXPORT___;
